/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { StatCardV2 } from '../../../components/v2';
import TableService from '../../../services/TableService';

const EMPTY_RESUMO = {
  totalNegativos: 0,
  valorTotalNegativo: 0,
  totalUsuarios: 0,
  valorTotal: 0,
};

const formatCurrency = (value) =>
  value != null
    ? value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
    : 'R$ 0,00';

const AportesResumoCards = ({ apiFilter, activeCard, onFilterByCard, refreshKey }) => {
  const [resumo, setResumo] = useState(EMPTY_RESUMO);
  const [loading, setLoading] = useState(false);

  const fetchResumo = useCallback(async () => {
    setLoading(true);
    try {
      const response = await TableService.request('aportes/resumo', apiFilter);
      setResumo(response?.data || EMPTY_RESUMO);
    } catch {
      setResumo(EMPTY_RESUMO);
    } finally {
      setLoading(false);
    }
  }, [apiFilter, refreshKey]);

  useEffect(() => {
    fetchResumo();
  }, [fetchResumo]);

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, sm: 6 }}>
        <StatCardV2
          label="Usuários com Saldo Negativo"
          valueFiltered={resumo.totalNegativos}
          valueTotal={resumo.totalUsuarios}
          totalCaption="no total"
          icon={<TrendingDownIcon />}
          color="error"
          loading={loading}
          active={activeCard === 'NEGATIVO'}
          onClick={() =>
            onFilterByCard(activeCard === 'NEGATIVO' ? null : 'NEGATIVO')
          }
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <StatCardV2
          label="Valor Total Negativo"
          value={formatCurrency(resumo.valorTotalNegativo)}
          icon={<AccountBalanceWalletIcon />}
          color="warning"
          loading={loading}
          active={activeCard === 'VALOR_NEGATIVO'}
          onClick={() =>
            onFilterByCard(activeCard === 'VALOR_NEGATIVO' ? null : 'VALOR_NEGATIVO')
          }
        />
      </Grid>
    </Grid>
  );
};

AportesResumoCards.propTypes = {
  apiFilter: PropTypes.object.isRequired,
  activeCard: PropTypes.string,
  onFilterByCard: PropTypes.func.isRequired,
  refreshKey: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
};

AportesResumoCards.defaultProps = {
  activeCard: null,
  refreshKey: false,
};

export default AportesResumoCards;
